import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { actionCloseShiftIntro } from 'lib/actions';
import { getShiftIntroOpen } from 'lib/selectors/getShiftIntroOpen';
import {
  MMEmbeddableZone,
  useEmbeddedEffect,
} from '@machinemetrics/mm-react-embeddable';
import { SHIFT_HANDOVER_HOST } from 'lib/appConfig';
import i18n from 'i18next';
import { getCurrentOperator } from 'lib/selectors/getCurrentOperator';
import { getMachine } from 'lib/selectors/getMachine';
import Routes from 'lib/utils/routes';
import PersistentDrawer, {
  PersistentDrawerBody,
  PersistentDrawerHeader,
  PersistentDrawerCloseButton,
} from '../PersistentDrawer';

const EmbeddedShiftIntro = ({ id, operator }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const machine = useSelector(getMachine);
  const [path, setPath] = useState('/intro');

  useEmbeddedEffect(id, 'shift-intro:close', () => {
    dispatch(actionCloseShiftIntro());
    // Navigate to select job after closing intro
    if (machine?.id) {
      history.push(Routes.machineIdSelectJobPath(machine.id));
    }
  });

  useEmbeddedEffect(id, 'shift-intro:setPath', (data) => {
    if (data?.path) {
      setPath(data.path);
    }
  });

  const context = {
    operatorId: operator?.id,
    operatorErpId: operator?.erpId,
    operatorName: operator?.name,
  };

  return (
    <MMEmbeddableZone
      id={id}
      src={`${SHIFT_HANDOVER_HOST}`}
      path={path}
      context={context}
      params={{
        language: i18n.language,
      }}
    />
  );
};

export const ShiftIntroWrapper = () => {
  const id = 'shift-intro-screen';
  const dispatch = useDispatch();
  const shiftIntroOpen = useSelector(getShiftIntroOpen);
  const currentOperator = useSelector(getCurrentOperator);

  const operator = {
    id: currentOperator?.id,
    erpId: currentOperator?.erpId,
    name: currentOperator?.name,
  };

  return (
    <PersistentDrawer
      isOpen={shiftIntroOpen}
      onClose={() => {
        return dispatch(actionCloseShiftIntro());
      }}
      placement="bottom"
      size="full"
    >
      <PersistentDrawerHeader>
        Hello Operator!
        <PersistentDrawerCloseButton />
      </PersistentDrawerHeader>
      <PersistentDrawerBody
        style={{
          position: 'relative',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          padding: 0,
          margin: 0,
        }}
      >
        <EmbeddedShiftIntro id={id} operator={operator} />
      </PersistentDrawerBody>
    </PersistentDrawer>
  );
};
